<template>
  <div id="app">
    <Header/>
    <router-view/>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'

export default {
  name: 'app',
  components: {
    Footer,
    Header
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue